import { render } from "./odn-modal-customer-list.vue?vue&type=template&id=6ea13f8d"
import script from "./odn-modal-customer-list.vue?vue&type=script&lang=js"
export * from "./odn-modal-customer-list.vue?vue&type=script&lang=js"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__